import { DarkModeRounded as DarkModeRoundedIcon, LightModeRounded as LightModeRoundedIcon } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { t } from 'i18next'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'

const ThemeToggle = () => {
  const { theme, setTheme } = useGlobalContext()

  return (
    <IconButton
      aria-label={t(theme === 'light' ? 'users.darkMode' : 'users.lightMode')}
      onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
      color="primary"
    >
      {theme === 'light' && <DarkModeRoundedIcon fontSize="small" />}
      {theme === 'dark' && <LightModeRoundedIcon fontSize="small" />}
    </IconButton>
  )
}

export default ThemeToggle
